<template>
    <div class="md-layout text-center login-fix-page">
        <div class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100 login-page-fix">
            <form @submit.prevent="login">
                <login-card header-color="green">
                    <h4 slot="title" class="title">GAIA - Administration</h4>
                    <md-field class="form-group md-invalid"
                        slot="inputs"
                        style="margin-bottom: 28px">
                        <label>Adresse email</label>
                        <md-input v-model="email" type="email"/>
                        <validation-error :errors="apiValidationErrors.email"/>
                    </md-field>
                    <md-field class="form-group md-invalid" slot="inputs">
                        <label>Mot de passe</label>
                        <md-input v-model="password" type="password"/>
						<validation-error :errors="apiValidationErrors.password"/>
                    </md-field>
                    <md-button slot="footer"
                        class="md-info"
                        @click="goToForgot">
                        Mot de passe oublié
                    </md-button>
                    <md-button slot="footer"
                        class="md-success"
                        type="submit">
                        Connexion
                    </md-button>
                </login-card>
            </form>
        </div>
    </div>
</template>

<script>
import { LoginCard, ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";

export default {
    components: {
        LoginCard,
        ValidationError,
    },
    mixins: [formMixin],
    computed: {
        isAuthenticated: function () {
            return this.$store.getters.isAuthenticated();
        },
    },
    data: () => ({
        email: "",
        password: "",
    }),
    methods: {
        async login() {
            const user = {
                data: {
                    type: "token",
                    attributes: {
                        email: this.email,
                        password: this.password,
                    },
                },
            };

            const requestOptions = {
                headers: {
                    Accept: "application/vnd.api+json",
                    "Content-Type": "application/vnd.api+json",
                },
            };

            try {
				this.resetApiValidation();
                await this.$store.dispatch("login", {user, requestOptions});
            } catch (e) {
            	if(e.response.data.errors) {
					let errorMessage = [this.checkMessageError(e.response.data.errors[0])]
					this.setApiValidation(errorMessage);
				} else {
					this.setApiValidation([{
						source: { pointer: '/data/attributes/email' },
						detail: 'Identifiants incorrects'
					}]);
				}
            }
        },
		checkMessageError(error) {
			let errorMessage = ''
			switch(error.status) {
				case '400':
					errorMessage = {
						source: { pointer: '/data/attributes/password' },
						detail: 'Le mot de passe est incorrect'
					}
					break
				case '422':
					errorMessage = {
						source: error.source,
						detail: 'L\'adresse email est invalide'
					}
					break
				default:
					errorMessage = {
						source: { pointer: '/data/attributes/email' },
						detail: 'Une erreur est survenue'
					}
					break
			}
			return errorMessage
		},
        goToForgot() {
            this.$router.push({name: 'Password Forgot'})
        },
    },
    mounted() {
        document.title = 'Gaia - Administration'
    }
};
</script>
<style scoped>
.login-fix-page {
    padding-bottom: 7em;
    padding-top: 4em;
}
</style>
